import { get, isEmpty, omit } from 'lodash';

import { CAMPAIGN_NAMES, PERSONALIZATION_STATUS } from 'constants/personalizations';
import { SHOP_IDS } from 'constants/shops';
import Settings from 'utils/Settings';

const PersonalizationsSelector = class {
  static getCampaignByName = (state, campaignName) => {
    return state.personalizations[campaignName];
  };

  static getAllCampaigns = state => {
    // grab all "personalizations" except the cookies and variations
    return omit(state.personalizations, ['variations', 'cookies']);
  };

  static getVariationData = state => {
    return state.personalizations?.variations;
  };

  static getVariationDataExists = state => {
    const variations = state.personalizations?.variations;
    return variations?.every(variation => {
      return !isEmpty(variation.content);
    });
  };

  static getIsExperimentLoading = (state, experimentName) => {
    const shouldWaitForExperiment = Settings.shopID === SHOP_IDS.US;
    const campaignData = PersonalizationsSelector.getCampaignByName(state, experimentName);
    return (
      shouldWaitForExperiment &&
      (!campaignData?.status || campaignData?.status === PERSONALIZATION_STATUS.LOADING)
    );
  };

  static getCampaignVariationData = (state, campaignName, variationIndex = 0) => {
    const campaign = PersonalizationsSelector.getCampaignByName(state, campaignName);

    return campaign?.variations?.[variationIndex]
      ? { ...campaign.variations[variationIndex], decisionId: campaign?.decisionId }
      : null;
  };

  static getShowIncentivizedSignupModal = state => {
    const incentivizedSignupModalCampaign = PersonalizationsSelector.getCampaignByName(
      state,
      CAMPAIGN_NAMES.INCENTIVIZED_SIGNUP_MODAL
    );
    const variationData = get(incentivizedSignupModalCampaign, [
      'variations',
      '0',
      'payload',
      'data',
    ]);

    let showIncentivizedSignupModal;
    let signupModal;

    switch (incentivizedSignupModalCampaign.status) {
      case PERSONALIZATION_STATUS.SUCCESS:
        const matchedId = variationData.contentfulEntryId;
        signupModal = Settings.signupModal.find(item => item.id === matchedId);
        showIncentivizedSignupModal = signupModal ? true : false;
        break;
      case PERSONALIZATION_STATUS.ERROR:
        showIncentivizedSignupModal = false;
        break;
      default:
        break;
    }

    return { showIncentivizedSignupModal, variationData, signupModal };
  };

  static getTargetedPageSectionCampaignData = (state, campaignName, experimentPageSections) => {
    const variationData = PersonalizationsSelector.getCampaignVariationData(state, campaignName);
    const isLoading = PersonalizationsSelector.getIsExperimentLoading(state, campaignName);

    const { payload, analyticsMetadata } = variationData || {};

    const currentVariationId = payload?.data?.variationId || null;
    const activePageSections = experimentPageSections
      ?.filter(
        experimentPageSection =>
          experimentPageSection.variationId === currentVariationId &&
          experimentPageSection.testName === campaignName
      )
      .map(experimentPageSection => experimentPageSection.content);

    return {
      activePageSections,
      analyticsMetadata: {
        dyDecisionId: variationData?.decisionId,
        dyVariationId: analyticsMetadata?.variationId,
      },
      isLoading,
    };
  };
};

export default PersonalizationsSelector;
